// export const esgModuleInfoForVenture = `## ESG Module quick tour

//The following **video** provides you with an overview of how to conduct an ESG Assessment with the ImpactNexus software solution.`

export const esgModuleInfoForVenture = `esg.tour.subtitle`
